import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexKnowledgebase',
  setup(__props) {

const KnowledgebaseSearch = defineAsyncComponent(() => import("@/components/theme/knowledgebase/KnowledgebaseSearch.vue"))
const FaqWidgets = defineAsyncComponent(() => import("@/components/theme/knowledgebase/FaqWidgets.vue"))
const BrowseArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/BrowseArticles.vue"))
const FeaturesFaq = defineAsyncComponent(() => import("@/components/theme/knowledgebase/FeaturesFaq.vue"))
const LatestArticles = defineAsyncComponent(() => import("@/components/theme/knowledgebase/LatestArticles.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Knowledgebase",
      mains: "Knowledgebase",
      title: "Knowledgebase"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(KnowledgebaseSearch)),
        _createVNode(_unref(FaqWidgets)),
        _createVNode(_unref(BrowseArticles)),
        _createVNode(_unref(FeaturesFaq)),
        _createVNode(_unref(LatestArticles))
      ])
    ])
  ], 64))
}
}

})